import { IToken } from "./token";
import { AuthResult } from '../enums';

export interface ITokenResponse {
    data: {
        success: boolean;
        authResult: AuthResult;
        message: string;
        token: IToken;
        tokenHex: string;
    }
}